export default "__VITE_ASSET__18674435__"